import "../styles/Earnings.css";
import "../styles/gdk";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { convertDate } from "../helpers/historyHelper";
import * as rewardsApi from "../services/ApiServices/ApiService";
import { logTrace } from "../services/ApiServices/LoggingService";

const Earnings = () => {
  const [history, setHistory] = useState(null);
  const [earningsList, setEarningsList] = useState(null);
  const [tokenExists, setTokenExists] = useState(false);
  const navigate = useNavigate();

  const addRow = (earning) => {
    const body = document.getElementById("earnings-body");
    const row = document.createElement("tr");

    const createCell = (textContent, options = {}) => {
      const cell = document.createElement("td");
      cell.scope = "col";
      cell.textContent = textContent || "";
      if (options.style) {
        Object.assign(cell.style, options.style);
      }
      return cell;
    };

    const quoteOrPolicyNumber =
      earning.promotionType === "Quotes"
        ? earning.quoteNumbers?.join(", \n") || ""
        : earning.policyNumbers?.join(", \n") || "";

    row.appendChild(createCell(earning.promotionName));
    row.appendChild(createCell(earning.promotionType));
    row.appendChild(createCell(quoteOrPolicyNumber, { style: { whiteSpace: "pre-wrap" } }));
    row.appendChild(createCell(earning.paymentStatus));
    row.appendChild(createCell(`$${earning.paymentAmount.toLocaleString()}`));
    row.appendChild(createCell(convertDate(earning.paymentDate)));

    body.appendChild(row);
  };

  const getUserPaymentHistory = async (token) => {
    const handleError = (error) => {
      logTrace(
        error,
        "error when calling rewardsApi.getUserPaymentHistory",
        "getUserPaymentHistory in Earnings.jsx"
      );
    };

    const handleSuccess = (responseData) => {
      setHistory(responseData);
    };

    await rewardsApi.getUserPaymentHistory(token, handleSuccess, handleError);
  };

  useEffect(() => {
    if (history !== null) {
      const updatedEarningsList = earningsList
        ? [...earningsList, ...history.list]
        : history.list;

      setEarningsList(updatedEarningsList);

      if (!tokenExists && history.token) {
        setTokenExists(true);
      }

      const body = document.getElementById("earnings-body");
      body.innerHTML = "";

      if (updatedEarningsList !== null && updatedEarningsList.length !== 0) {
        updatedEarningsList.forEach((earning) => {
          addRow(earning);
        });
      }
    }
  }, [history]);

  useEffect(() => {
    getUserPaymentHistory("");
    setEarningsList(null);
  }, []);

  return (
    <div>
      <div className="container-fluid">
        <div className="header-container">
          <h3 className="header-main">Earnings History Dashboard</h3>
        </div>
      </div>
      <div className="data-table">
        <table className="table table-striped table-bordered" id="earnings-table">
          <thead>
            <tr>
              <th scope="col">Promotion Name</th>
              <th scope="col">Promotion Type</th>
              <th scope="col">Policy/Quote Number</th>
              <th scope="col">Payment Status</th>
              <th scope="col">Earnings</th>
              <th scope="col">Date</th>
            </tr>
          </thead>
          <tbody id="earnings-body"></tbody>
        </table>
        {history?.token && (
          <button
            type="button"
            className="Earnings-footer"
            data-testid="submit"
            data-trackid="show-more"
            data-track-type="button"
            onClick={() => getUserPaymentHistory(history.token)}
          >
            Show More
          </button>
        )}
      </div>
      <button
        type="button"
        data-testid="submit"
        className="btn btn--secondary btn--pull-right"
        data-trackid="return-home"
        onClick={() => navigate("/home")}
      >
        Return Home
      </button>
    </div>
  );
};

export default Earnings;
